export const Norwegian = {
  'LANGUAGE_KEY': 'no',
  'language': 'Norsk',
  'exportExcel': 'Eksporter til Excel',
  'loading': 'Laster...',
  'typeToSearch': 'Skriv for å søke',
  'collapse': 'Kollapse',
  'copyUrl': 'Kopier adresse',
  'sendUrl': 'Send adresse på epost',
  'attributesHeader': 'Kjennetegn',
  'qaHeader': 'QA',
  'attribute': 'Kjennetegn',
  'attributeSingular': 'Kjennetegn',
  'value': 'Verdi',
  'unit': 'Enhet',
  'qa': 'QA',
  'clip': 'Klippbilde',
  'equipmentsHeader': 'Utstyr',
  'equipmentsAnalysisHeader': 'Utstyrsanalyse',
  'modelType': 'Modeltype',
  'manufacturer': 'Fabrikat',
  'parentName': 'Overliggende navn',
  'schematicsHeader': 'Skjematikk',
  'uploadImages': 'Last opp bilder',
  'uploadSchemas': 'Last opp skjema',
  'imageViewer': 'Bildeviser',
  'categoriesTitle': 'Endre bildekategori',
  'categoriesUpdate': 'Oppdater bildekategori',
  'legalChild': 'Lovlige sub-noder',
  'enterNewName': 'Vennligst skriv navnet på den nye noden',
  'addChild' : 'Ny node',
  'deleteNode': 'Slett',
  'deleteConfirm': 'Er du sikker på at du vil slette?',
  'save':'Lagre',
  'delete': 'Slett',
  'cancel': 'Avbryt',
  'deleteWithChildNotAllowed': 'Sletting av noder med subnoder er ikke tillatt. Venligst slett subnoder først',
  'changeModelType': 'Endre modeltype',
  'legalModelTypes': 'Lovlige modeltyper',
  'SettingsHeader': 'Innstillinger',
  'clipConnectionError': 'Kunne ikke oppdatere klippet.',
  'SelectAll': 'Velg alle',
  'DeleteImages': 'Slett bilder',
  'ConfirmDelete': 'Er du sikker du vil slette valgte bilder?',
  'Upload': 'Last opp',
  'Browse': 'Legg til filer',
  'noSchemaFound': 'Ingen skjema funnet',
  'enterSchemaName': 'Skriv inn navnet for skjemaet',
  'Close': 'Lukk',
  'CutImages': 'Klipp ut',
  'PasteImages': 'Lim inn',
  'ClipBoard': 'Utklippstavle',
  'schematicsConnectionError': 'Oppdatering av metadata for skjema feilet.',
  'startDrawSchematicClips': 'Tegn klipp',
  'connectDrawSchematicClips': 'Koble klipp',
  'deletingSchemaLink': 'Slett klipp',
  'copyingSchemaLink': 'Kopier klipp',
  'infoTextDrawClips': 'For å tegne et nytt klipp, klikk "Tegn klipp" knappen, hold inne CTRL og dra et rektangel i skjemaet.',
  'infoTextConnectClips': 'For å koble et klipp, til en asset, klikk "Koble klipp" knappen, naviger til en asset i treet, og klikk på et klipp i skjemaet.',
  'infoTextDeleteClips': 'For å slette et klipp, klikk "Slett klipp" knappen, og klikk klippet du vil slette i skjemaet.',
  'infoTextCopyClips' : 'For å kopiere et klipp, klikk "Kopier klipp" knappen, hold inne CTRL og dra det kopierte klippet til ønsket posisjon.',
  'EditImageTitle': 'Rediger bildekategori',
  'RotateImage' : 'Roter bildet 90 grader med klokka',
  'ConfirmMove': 'Flytte valgte bilder?',
  'savingClip': 'Lagrer klipp',
  'deletingClip': 'Sletter klipp',
  'dropInfoText': 'Slipp bilder her',
  'schematicsHelpTitle': 'Skjematikkoperasjoner',
  'imageListHeader': 'Bilder',
  'manufactureYear': 'Fabrikasjonsår',
  'typeDesignation': 'Typebetegnelse',
  'showfullSizeImage': 'Vis høy oppløsning',
  'NoSearchResults': 'Ingen treff for gitt søkeord',
  'ExpandImgTooltip': 'Åpne bilde i nytt vindu',
  'contains': 'Inneholder',
  'doesNotContain': 'Inneholder ikke',
  'isEqualTo': 'Er lik',
  'isNotEqualTo': 'Er ikke lik',
  'startsWith': 'Begynner med',
  'endsWith': 'Slutter med',
  'and': 'Og',
  'or': 'Eller',
  'filter': 'Filtrer',
  'clearFilter': 'Fjern filter',
  'filterInfo': 'Vis rekker med verdi som:',
  'groupInfo': 'Dra en kolonne hit for å gruppere på den',
  'NoImagesFound': 'Ingen bilder funnet',
  'requestFailed': 'Kunne ikke koble til',
  'retry': 'Prøv igjen',
  'cut': 'Klipp',
  'Copy': 'Kopier url',
  'CopyToolTip': 'Kopier url til utklippstavle',
  'RowNotSelected': 'Ingen rad er valgt',
  'renameSchematic': 'Gi nytt navn',
  'enterNewSchemaName': 'Skriv inn det nye navnet for skjemaet',
  'confirmMove': 'Er du sikker på at du vil flytte denne noden?',
  'documentsHeader': 'Dokumenter',
  'DownloadImage': 'Last ned bildet',
  'ToggleRecursiveDocuments': 'Vis dokumenter for undernoder',
  'showingDocuments': 'Forhåndsvisning av valgt dokument',
  'gotoAsset': 'Gå til node',
  'documentRequirementsHeader': 'Dokumentkrav',
  'done': 'Ferdig',
  'SelectNode': 'Velg node',
  'clickToShowDocumentFrontpages': 'Velg et dokument for å vise forsider',
  'ImageList': 'Bilder',
  'Attributes': 'Kjennetegn',
  'Q&A': 'QA',
  'Equipments': 'Utstyr',
  'Schematics': 'Skjematikk',
  'Documents': 'Dokumenter',
  'Document requirements': 'Dokumentkrav',
  'otherTabs': 'Andre valg',
  'showingEquipmentFor': 'Viser utstyr for',
  'SelectDocument': 'Velg dokument',
  'toggleClipInfo': 'Vis klipp informasjon',
  'expand': 'Ekspander',
  'changeConnectedNode': 'Gå til koblet node',
  'legalConnectedNodes': 'Noder som er koblet',
  'ClipNotConnected': 'Klippet har ingen info eller er ikke koblet til utstyr.',
  'showClipInfoTooltip': 'Vis klipp-informasjon',
  'hideClipInfoTooltip': 'Skjul klipp-informasjon',
  'EqAnCategory': 'År',
  'EqAnAmount': 'Antall',
  'EqAnNoData': 'Naviger i treet for å se finne dokumenter'
};



/** WEBPACK FOOTER **
 ** app/Localization/no.js
 **/